export default __webpack_public_path__ + "media/assets/fonts/roboto-slab-v13-latin-500-c62929f22e5aa6ed1162ef7e821b7691.woff";